import axios from "axios";
/* eslint-disable vue/multi-word-component-names */
import Vue from "vue";
import App from "./App.vue";
import router from "./router";

Vue.config.productionTip = false;

// Axios
axios.defaults.baseURL = process.env.VUE_APP_PATIENT_API_URL;

// Pinia
import { createPinia, PiniaVuePlugin } from "pinia";
Vue.use(PiniaVuePlugin);
const pinia = createPinia();

// Composition API
import VueCompositionAPI from "@vue/composition-api";
Vue.use(VueCompositionAPI);

// Google Analytics (GA4)
import VueGtag from "vue-gtag";
import { resolvePartnerChannel } from "@/utils/partnerChannel";
const gaMeasurementIdsByChannel = {
  MWM: process.env.VUE_APP_GA_MEASUREMENT_ID_MWM,
  LAUNCHIT_HEALTH: process.env.VUE_APP_GA_MEASUREMENT_ID_LAUNCHIT_HEALTH,
};
const gaMeasurementId =
  gaMeasurementIdsByChannel[resolvePartnerChannel(window.location.search)];
if (gaMeasurementId) {
  Vue.use(VueGtag, {
    config: { id: gaMeasurementId },
  });
}

// PrimeVue
import "@/plugins/primevue";
import "@/assets/mwmcc-primevue.scss";

// Styles
import "@/assets/mwmcc.scss";

import i18n, { loadSupportedLanguages } from "./plugins/i18n";
import { loadBranding } from "./utils/branding";

// Fire-and-forget: swaps in the Launchit Health logo/name when the page was loaded from one of
// the hostnames configured in Branding:LaunchitHealthHostnames (same deployment, different brand).
loadBranding();

// Fire-and-forget: locks the UI to a single language as soon as it resolves if this
// deployment only has one enabled (see loadSupportedLanguages' doc comment). Not awaited so it
// doesn't delay the initial mount, matching how the reCAPTCHA site key is fetched in
// authStore.setupRecaptcha().
loadSupportedLanguages();

// set up localization global object for questionnaire engine
if (process.env.VUE_APP_LOCALE != undefined) {
  (window as any).regionalSettings = {
    regionCode: process.env.VUE_APP_LOCALE.split("-")[1],
    defaultLocale: process.env.VUE_APP_LOCALE,
    timeZone: undefined,
  }
}

new Vue({
  i18n,
  pinia,
  router,
  render: (h) => h(App),
}).$mount("#app");
